import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_departamento`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_departamento/list`);
  return response;
};

const getAllComplete = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_departamento/get/all`);
  return response;
};

const getAllActive = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_departamento/get/active`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_departamento/${id}`);
  return response;
};

const getByOdooId = async (odooId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_departamento/odoo/${odooId}`);
  return response;
};

export {getAll, getList,getAllComplete,getAllActive,getById,getByOdooId};